module.exports = __webpack_public_path__ + "media/images/medupp-logo-dark-94133af4fa53a7a4f5171469c73bff8f.png";